<template>
  <div id="" class="mainDiv">
    <div>
      <el-button type="primary" size="small" @click="goBack" class="head-li"
        >返回</el-button
      >
    </div>
    <div class="list">
      <div
        v-for="(item, index) in invigilateList"
        :key="item.examsUsersId"
        class="list-li"
      >
        <div class="list-top">
          <div class="list-top-left">
            <p>证件照</p>
            <!-- <img src="@/static/images/0210326164429.png" alt=""> -->
            <img :src="url + item.userPhoto" alt="" />
          </div>
          <div class="list-top-right">
            <p>实时视频画面</p>
            <image-frame
              class="list-top-right-img"
              :imglist="item.photoFrameList"
            ></image-frame>
            <!-- <image-frame class="list-top-right-img" :imglist="testimglist"></image-frame> -->
          </div>
        </div>
        <div class="list-mid">
          {{ item.fullName }} 准考证号：{{ item.admissionCard }}
        </div>
        <div
          class="invigilate-btn"
          @click="goInvigilateDetails(item.examsUsersId)"
        >
          单独巡考
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/invigilate/invigilateList'
import ImageFrame from '@/components/image-frame'
import { setHost } from '@/utils/common'

export default {
  name: 'InvigilateBatch',
  components: {
    ImageFrame,
  },
  data() {
    return {
      host: '',
      paperId: '',
      invigilateList: [],
      testimglist: [
        { url: '/wwwimg/PhotoFrame/36/1617802815.png' },
        { url: '/wwwimg/PhotoFrame/36/1617802816.png' },
        { url: '/wwwimg/PhotoFrame/36/1617802995.png' },
      ],
      timer: '',
    }
  },
  methods: {
    getExamsUsersTourList() {
      let that = this
      let reqdata = {
        examsPaperId: this.paperId,
      }
      api.getExamsUsersTourList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          if (data.data) {
            that.invigilateList = data.data
          }
        } else {
          that.$message.error(data.msg)
        }
        this.timer = setTimeout(() => {
          // 过一段时间就要重新获取实时画面
          that.getExamsUsersTourList()
        }, 15000)
      })
    },
    goInvigilateDetails(id) {
      this.$router.push({
        name: 'InvigilateDetails',
        query: { exams_users_id: id, examiner_id: this.examinerId },
      })
    },
    goBack() {
      window.history.go(-1)
    },
  },
  mounted() {
    this.paperId = this.$route.query.paper_id
    this.examinerId = this.$route.query.examiner_id
    this.host = setHost()
    this.getExamsUsersTourList()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  margin-top: 10px;
}
.list-li {
  border: 2px solid #ebebeb;
  margin-right: 20px;
  margin-bottom: 10px;
}
.list-top {
  display: flex;
  justify-content: left;
}
.list-top p {
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.7);
  color: white;
  padding: 5px;
  font-size: 14px;
}
.list-top-left {
  position: relative;
}
.list-top-right {
  position: relative;
}
.list-top-left > img {
  width: 180px;
  height: 240px;
}
.list-top-right-img {
  position: relative;
  width: 250px;
  height: 240px;
}
.list-mid {
  padding: 5px;
  text-align: center;
  font-size: 14px;
}
.invigilate-btn {
  cursor: pointer;
  background-color: #eeeeee;
  padding: 5px;
  text-align: center;
}
</style>
